import { WhitelistingStatus } from "../common/enums/whitelisting.enum";

export const ACCESS_TOKEN_KEY = "token";

//COLORS
export const RED_COLOR = "#FD2B2B0D";
export const GREEN_COLOR = "#2BFDA70D";
export const BLUE_COLOR = "#38D6F90D";
export const INPUT_COLOR = "#122242";
export const GREEN_TEXT_COLOR = "#2bfda7";
export const BLUE_TEXT_COLOR = "#38D6F9";
export const RED_TEXT_COLOR = "#EE4C4C";

export const whitelistingStatusColor: Map<WhitelistingStatus, string[]> =
  new Map([
    [WhitelistingStatus.Approved, [GREEN_COLOR, GREEN_TEXT_COLOR]],
    [WhitelistingStatus.Denied, [RED_COLOR, RED_TEXT_COLOR]],
    [WhitelistingStatus.Pending, [BLUE_COLOR, BLUE_TEXT_COLOR]],
  ]);

export const TRANSACTION_ERROR_IDENTIFIER = "Error Message: ";
export const GOVERNANCE_ERROR_IDENTIFIER = "GOVERNANCE-ERROR: ";
export const TRANSFER_ERROR_IDENTIFIER = "Transfer: ";

export const MESSAGE_TYPE = {
  SUCCESS: "success",
  ERROR: "error",
};
